import { gql } from '__generated__';

const AddEventMutation = gql(`
  mutation AddEvent($input: AddEventInput!) {
    addEvent(input: $input) {
      id
    }
  }
`);

export default AddEventMutation;
